import { ButtonERP } from "@finanedi.es/storybook"
import { PerceptorGetDatosDeclaracionModelo190DtoProps } from "api/DTOs/PerceptorGetDatosDeclaracionModelo190Dto"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import PerceptorsTemplate from "./PerceptorsTemplate"
import { Modelo190Form } from "../DeclaracionModelo190"

const Perceptores190 = ({
  setValue,
  values,
  errors,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  values: $TSMigrationFixMe
  errors: FieldErrors<Modelo190Form>
}) => {
  const { t } = useTranslation()
  const perceptorsCount = values?.perceptores?.length ?? 1
  const handleAddPerceptor = () => {
    const current = Array.isArray(values?.perceptores) ? values.perceptores : []
    const newPerceptor = {}
    setValue("perceptores", [...current, newPerceptor], {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleDeletePerceptor = (index: number) => {
    const current = Array.isArray(values?.perceptores) ? values.perceptores : []
    const updated = current.filter(
      (_: PerceptorGetDatosDeclaracionModelo190DtoProps, idx: number) =>
        idx !== index
    )
    setValue("perceptores", updated, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <div
      title='Perceptores190'
      className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-5'
    >
      <ButtonERP
        label={`${t("taxSummary.declaracion.addPerceptor")}`}
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddPerceptor}
      />

      {Array.from({ length: perceptorsCount }).map((_, index) => (
        <PerceptorsTemplate
          t={t}
          // eslint-disable-next-line react/no-array-index-key
          key={`perceptors_${index}`}
          text={`${t("modelo190.perceptors.perception")} ${index + 1}`}
          values={values}
          setValue={setValue}
          perceptorIndex={index}
          handleDelete={() => handleDeletePerceptor(index)}
          errors={errors}
        />
      ))}
    </div>
  )
}

export default Perceptores190
